import { SINGLE_CARD_WIDTH } from "GlobalConstant/ClassNames";
import getThemeClasses from "@oxygen/theme";

export const MAKE_ENDPOINT = "/:maskingName([a-zA-Z0-9-]+)-cars/";
export const AD_SLOTS = {
  TOP_AD: {
    id: "div-gpt-ad-1607346835798-0",
    path: "/1017752/CarWale_Mobile_Make_320x50_Control",
    size: [
      [320, 50],
      [320, 100],
      [320, 150],
      [300, 100],
      [300, 150],
    ],
  },
  MIDDLE_AD: {
    id: "div-gpt-ad-1607346939190-0",
    path: "/1017752/CarWale_Mobile_Make_300x250_VariantA",
    size: [
      [336, 280],
      [300, 250],
    ],
  },
  BOTTOM_AD: {
    id: "div-gpt-ad-1435297201507-0",
    path: "/1017752/CarWale_Mobile_ROS_300x250",
    size: [
      [300, 250],
      [336, 280],
      [300, 100],
      [300, 150],
      [320, 150],
      [320, 100],
      [320, 50],
    ],
  },
};

export const CampaignCtaText = "Get Best Offer";
export const OFFERS_TEXT = "OFFERS AVAILABLE";

export const VERSION_CARD_WIDTH = {
  SINGLE: SINGLE_CARD_WIDTH,
  MULTIPLE: getThemeClasses(`
    width-72 md:width-full;
  `),
};

export const AD_SLOTS_DESKTOP = {
  TOP_AD: {
    id: "div-gpt-ad-1517217436667-0",
    path: "/1017752/Carwale_Dsk_Make_970x90",
    size: [
      [950, 90],
      [960, 90],
      [970, 90],
      [960, 60],
      [728, 90],
      [960, 66],
      [970, 66],
      [970, 60],
      [643, 90],
    ],
  },
  SECOND_AD: {
    id: "div-gpt-ad-1396440106184-0",
    path: "/1017752/NewCar_300x250",
    size: [
      [300, 250],
      [300, 100],
      [300, 600],
      [240, 400],
      [234, 60],
      [216, 36],
      [216, 54],
      [200, 200],
    ],
  },
  THIRD_AD: {
    id: "div-gpt-ad-1396440106184-1",
    path: "/1017752/NewCar_300x250_BTF",
    size: [[300, 150]],
  },
  STICKY_AD: {
    id: "div-gpt-ad-1396440106184-9",
    path: "/1017752/NewCar_300x600",
    size: [
      [300, 250],
      [300, 100],
      [300, 600],
      [240, 400],
      [234, 60],
      [216, 36],
      [216, 54],
      [200, 200],
    ],
  },
};
